import init from '@/pages/base'
import App from './App.vue'
import NewsletterSubscribeForm from './NewsletterSubscribeForm.vue'

import 'vue-universal-modal/dist/index.css'

import '../../styles/global.scss';
import AuthService from "@/services/AuthService";
import EventBusService from "@/services/EventBusService";
import { getError } from "@/utils/helpers";
import globalStore from "@/utils/global-store";
import { watchEffect } from "vue";
import { performLoginDomChanges, performLogoutDomChanges } from "./auth-dom-changes";

init(App, '[data-buggyfit-global]', (app) => {
    (window as any).buggyFitLogout = function() {
        AuthService.logout().then(() => {
            console.log('logout successful');
            EventBusService.$emit('user.logout');
        }).catch(error => {
            //console.warn(error);
            console.warn('logout failed', getError(error));
        });
    };

    watchEffect(() => {
        if( globalStore.data.loggedIn.value ) {
            performLoginDomChanges();
        }
        else {
            performLogoutDomChanges();
        }
    });
});

init(NewsletterSubscribeForm, '.newsletter.elementor-element .elementor-form', (app) => {
    // console.log('NewsletterSubscribeForm target found');
});

window.addEventListener('DOMContentLoaded', function() {
    const selectorAttribute = 'data-bf-region-contact-link';
    document.querySelectorAll(`[${selectorAttribute}]`).forEach(function(el) {
        el.addEventListener('click', function(event) {
            event.preventDefault();
            EventBusService.$emit('modals.region.contact.open', {
                region: parseInt((event.currentTarget as HTMLElement).getAttribute('data-bf-region-contact-link') || '-1')
            });
        });
    });
});
